import { ROLE_ENUM } from "@webkit/enums/role.enum";
import { PersonDto } from "@dtos/person.dto";

export class UserDto {

  constructor(

    public username?: string,
    public password?: string,
    public person?: PersonDto,
    public role?: ROLE_ENUM.HOST | ROLE_ENUM.GUEST

  ) { }


}